import { LotStatus } from "@/enums/LotStatus";

interface StatusTextOptions {
  form?: "long" | "short" | "action";
}

/**
 * Get formatted status text for display in UI
 * @param status - The lot status from LotStatus enum
 * @param options - Options for formatting the text
 * @returns Formatted status text
 */
export const getStatusText = (
  status: string,
  options: StatusTextOptions = {}
): string => {
  const { form = "long" } = options;

  if (form === "short") {
    switch (status) {
      case LotStatus.UNDER_CONTRACT:
        return "contract";
      case LotStatus.UNCONDITIONAL:
        return "unconditional contract";
      case LotStatus.HOLD:
        return "hold";
      default:
        return "hold";
    }
  }

  if (form === "action") {
    switch (status) {
      case LotStatus.UNDER_CONTRACT:
        return "under contract";
      case LotStatus.UNCONDITIONAL:
        return "unconditional";
      case LotStatus.HOLD:
        return "on hold";
      default:
        return "on hold";
    }
  }

  switch (status) {
    case LotStatus.UNDER_CONTRACT:
      return "Under Contract";
    case LotStatus.UNCONDITIONAL:
      return "Unconditional";
    case LotStatus.HOLD:
      return "On Hold";
    default:
      return "On Hold";
  }
};
